import Cesium from 'cesiumDll/Cesium'

Cesium.Imagery.loadingImageryCount = 0

Cesium.Imagery.prototype.__defineSetter__('state', function(value) {
  if (value === Cesium.ImageryState.TRANSITIONING && this._state !== Cesium.ImageryState.TRANSITIONING) {
    // Starting to transition.
    Cesium.Imagery.loadingImageryCount++
  } else if (value !== Cesium.ImageryState.TRANSITIONING && this._state === Cesium.ImageryState.TRANSITIONING) {
    // Finishing transition to transition.
    Cesium.Imagery.loadingImageryCount--
    // if (Cesium.Imagery.loadingImageryCount === 0) {
    //   // Done loading all imagery.
    // }
  }
  this._state = value
})
Cesium.Imagery.prototype.__defineGetter__('state', function() {
  return this._state
})


// WEBPACK FOOTER //
// ./src/lib/ImageryMixin.js